import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/pt';
import { PATHS } from '@/routes/paths';
import { cn } from '@/lib/utils';
import { useNextLiveClass } from './use-next-live-class';
import liveScreenIcon from '@/assets/images/icons/live-screen.png';

function formatHour(momentDate) {
  return momentDate.minutes() === 0 ? momentDate.format('H[h]') : momentDate.format('H[h]mm');
}

export function NextClassBanner({ className }) {
  const { t } = useTranslation();
  moment.locale(t('language.language'));

  const { nextLiveClass, loading } = useNextLiveClass();

  if (loading || !nextLiveClass) {
    return null;
  }

  const startDateTime = moment(nextLiveClass['initial-date']);
  const endDateTime = moment(nextLiveClass['end-date']);
  const courseNames = (nextLiveClass.courses || [])
    .map(course => course.name)
    .filter(Boolean)
    .join(', ');

  return (
    <div className={cn('relative flex flex-col gap-6 overflow-hidden rounded-[24px] bg-gradient-to-r from-[#00b8d9] to-[#006c9c] p-6 shadow-card sm:flex-row sm:items-center sm:justify-between', className)}>
      <div className="flex items-center gap-6">
        <img
          src={liveScreenIcon}
          alt=""
          aria-hidden="true"
          className="hidden h-20 w-20 object-contain drop-shadow-sm sm:block"
        />

        <div className="flex flex-col items-start gap-2">
          <p className="text-sm font-bold text-white">{`Próxima aula · ${startDateTime.format('dddd')}, ${startDateTime.format('DD/MM')} ${formatHour(startDateTime)} às ${formatHour(endDateTime)}`}</p>
          <p className="text-3xl font-black leading-tight text-white">{nextLiveClass.title}</p>
          {courseNames && <p className="text-sm font-bold text-white/90">{courseNames}</p>}
        </div>
      </div>

      <Link
        to={PATHS.LIVE_CLASSES.LIST}
        className="flex h-9 shrink-0 items-center justify-center self-start rounded-full px-4 text-sm font-bold text-white transition-transform duration-100 active:scale-[0.97] sm:self-center"
        style={{
          background: 'var(--color-mission-light)',
          boxShadow: '0 3px 0 color-mix(in srgb, var(--color-mission-light) 72%, #000), 0 4px 8px rgba(0,0,0,0.18)'
        }}
      >
        Horários
      </Link>
    </div>
  );
}
